import { composeIO } from 'react-compose-io'
import { validacaoCicloIO } from './ValidacaoCiclo.IO'
import ValidacaoCicloView from './ValidacaoCiclo.View'

export const ValidacaoCiclo = composeIO(ValidacaoCicloView, validacaoCicloIO)
